export { isWeChat, isAlipay, isWeCom, isDingTalk } from './Platform';